class Accordeon {

    constructor(element) {
        console.log('Accordeon.constructor', element);
        this.element = element;
        this.items = this.element.getElementsByClassName('accordeon-item');
        this.onClick = this.onClick.bind(this);
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('headline')[0].addEventListener('click', this.onClick);
        }
    }

    destroy() {
        console.log('Accordeon.destroy', this.element);
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('headline')[0].removeEventListener('click', this.onClick);
        }
    }

    onClick(event) {
        console.log('Accordeon.onClick', event, event.currentTarget.parentElement);
        event.preventDefault();
        let item = event.currentTarget.parentElement;
        item.classList.toggle('selected');

        /*
        let selected = item.classList.contains('selected') ? true : false;
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].classList.remove('selected');
        }
        if (!selected) {
            item.classList.add('selected');
        }
        */
    }
}

Accordeon.elementClassName = 'accordeon';
Accordeon.instances = [];
Accordeon.init = function () {
    console.log('Accordeon.init');
    var elements = document.getElementsByClassName(Accordeon.elementClassName);
    for (const element of Array.from(elements)) {
        Accordeon.instances.push(new Accordeon(element));
    }
    console.log('Accordeon.instances.length', Accordeon.instances.length);
};

Accordeon.onDispose = function () {
    console.log('Accordeon.onDispose');
    while (Accordeon.instances.length) {
        console.log('Accordeon.instances.length', Accordeon.instances.length);
        let instance = Accordeon.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default Accordeon;


if (module.hot) {
    module.hot.dispose(Accordeon.onDispose);
}
